// Akkordeon.
// var template_path = $('html').data('path');
var template_path = accordionJs.pluginsUrl;
// console.log(template_path);
$('.accordion').addClass('js').find('.a-header').each(function (index, value) {
    $(this).wrap('<a class="a-link" href="#" aria-expanded="false" aria-haspopup="true" role="button"></a>').parent().append('<i class="a-icon"><svg role="img" class="symbol" aria-hidden="true" focusable="false"><use xlink:href="' + template_path + '/acc-icons.svg#arrow-down"></use></svg></i>');
})

$('.a-link').click(function (e) {
    e.preventDefault();
    var accLink = $(this);
    var accParent = $(this).parent();

    if (accParent.hasClass('a-open')) {
        $('.a-open .a-content').slideUp(500).promise().done(function () {
            accLink.find('.a-icon').replaceWith('<i class="a-icon"><svg role="img" class="symbol" aria-hidden="true" focusable="false"><use xlink:href="' + template_path + '/acc-icons.svg#arrow-down"></use></svg></i>');
            $('.a-open').removeClass('a-open');
            accLink.attr('aria-expanded', false);
        });
    } else {
        $('.a-open .a-content').slideUp(500).promise().done(function () {
            accLink.find('.a-icon').replaceWith('<i class="a-icon"><svg role="img" class="symbol" aria-hidden="true" focusable="false"><use xlink:href="' + template_path + '/acc-icons.svg#arrow-up"></use></svg></i>');
            $('html, body').animate({
                scrollTop: (accParent.offset().top - 145)
            }, 500);

            // $(this).attr('style', function (i, style) {
            //     return style.replace(/height\s*:\s*[^;]+;\s*/g, '');
            // });
            $('.a-content').css('height', 'auto');
            $('.a-open').removeClass('a-open');
            $('.accordion').find('a').attr('aria-expanded', false);
            accLink.next().slideDown(500);
            accParent.addClass('a-open');
            accLink.attr('aria-expanded', true);
            addHashToUrl(accParent.attr('id'));
        });
    }
    return false;
});

$('.a-link').mouseup(function () {
    this.blur();
});

// ACHTUNG: Das zerstört Skiplinks!!!
// $('a[href^="#"]').on('click', function(e){
//   var href = $(this).attr('href');
//   if (href.len >0) {
//     $('html, body').animate({
//       scrollTop:$(href).offset().top-50
//     },'slow');
//   }
//
//   e.preventDefault();
// });

// $('.a-link').click(function (e) {
//     e.preventDefault();
//     var accLink = $(this);
//     var accParent = $(this).parent();

//     if (accParent.hasClass('a-open')) {
//         $('.a-open .a-content').slideUp(500).promise().done(function () {
//             accLink.find('.a-icon').replaceWith('<i class="a-icon"><svg role="img" class="symbol" aria-hidden="true" focusable="false"><use xlink:href="' + template_path + '/acc-icons.svg#arrow-down"></use></svg></i>');
//             $('.a-open').removeClass('a-open');
//             accLink.attr('aria-expanded', false);
//         });
//     }
//     else if (!accParent.hasClass('a-open')) { 
//         $('.a-content').attr('style', function(i, style) {
//             return style.replace(/height\s*:\s*[^;]+;\s*/g, '');
//           });
//     }
//     else {
//         $('.a-open .a-content').slideUp(500).promise().done(function () {
//             accLink.find('.a-icon').replaceWith('<i class="a-icon"><svg role="img" class="symbol" aria-hidden="true" focusable="false"><use xlink:href="' + template_path + '/acc-icons.svg#arrow-up"></use></svg></i>');
//             $('html, body').animate({
//                 scrollTop: (accParent.offset().top - 145)
//             }, 500);

//             $('.a-open').removeClass('a-open');
//             $('.accordion').find('a').attr('aria-expanded', false);
//             accLink.next().slideDown(500);
//             accParent.addClass('a-open');
//             accLink.attr('aria-expanded', true);
//             addHashToUrl(accParent.attr('id'));
//         });
//     }
//     return false;
// });

